import { ArbitrageDetailItem } from '@/api/placementApi.schemas';

const useArbitrageSummaryData = (data: ArbitrageDetailItem | undefined) => {
  const supports = data?.supports;

  const riskAligned =
    supports?.newSrri != null && supports?.currentSrri != null && supports.newSrri <= supports.currentSrri;
  const totalReinvested =
    supports?.supportsInvestis?.reduce((acc, support) => acc + (support.montantNetAInvestir ?? 0), 0) ?? 0;
  const exitFees = supports?.supportsDesinvestis?.reduce((acc, support) => acc + (support.fraisSortie ?? 0), 0) ?? 0;
  const entryFees = supports?.supportsInvestis?.reduce((acc, support) => acc + (support.fraisEntree ?? 0), 0) ?? 0;

  return {
    riskAligned,
    totalReinvested,
    exitFees,
    entryFees,
    totalFees: exitFees + entryFees,
  };
};

export default useArbitrageSummaryData;
